import { useContext, useEffect, useState } from "react";
import { getData } from "src/actions/getData";
import PageHeader from "src/components/PageHeader";
import Table from "src/components/Table";
import shopContext from "src/context/shopContext";
import { numberWithCommas } from "src/utils/thousandSeprator";
import { TbEyeSearch } from "react-icons/tb";
import Modal from "src/components/Modal";
import ModalHeader from "src/components/Modal/ModalHeader";
import ModalBody from "src/components/Modal/ModalBody";
import ModalFooter from "src/components/Modal/ModalFooter";
import TwinButton from "src/components/TwinButton";
import { completedStatuses } from "src/settings/config";
import FilterColumn from "src/components/Table/FilterColumn";
import { FilterFn } from "src/components/Table/FilterFn";
import moment from 'jalali-moment';


function extractVouchers(orders) {
    const vouchersMap = {};

    orders.forEach(order => {
        if (order.coupon_lines && order.coupon_lines.length > 0 && completedStatuses.includes(order.status)) {
            order.coupon_lines.forEach(coupon => {
                const code = coupon.code;

                if (!vouchersMap[code]) {
                    vouchersMap[code] = {
                        voucherCode: code,
                        orders: []
                    };
                }
                vouchersMap[code].voucherType = coupon.discount_type
                vouchersMap[code].orders.push({
                    id: order.id,
                    fullName: order.fullName,
                    total: order.total,
                    line_items: order.line_items,
                    voucherAmount: coupon.discount
                });
            });
        }
    });

    // تبدیل به آرایه
    return Object.values(vouchersMap);
}

export default function VoucherStatistics() {
    const [vouchersData, setVouchersData] = useState()
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [rowData, setRowData] = useState()

    const [vouchersApiData, setVouchersApiData] = useState()

    useEffect(() => {
        const controller = new AbortController(); // برای لغو درخواست
        const signal = controller.signal;

        getData(setVouchersApiData, "/coupons", {}, signal)

        return () => {
            controller.abort();
        };
    }, [])


    const { orders, setOrders } = useContext(shopContext)
    useEffect(() => {
        if (!orders) {
            const controller = new AbortController(); // برای لغو درخواست
            const signal = controller.signal;

            getData(setOrders, "/orders", {}, signal);

            return () => {
                controller.abort();
            };
        }
    }, [])

    useEffect(() => {
        if (orders && vouchersApiData) {
            let vouchers = extractVouchers(orders)

            vouchers = vouchers.map(voucher => {
                let sumVoucherAmount = 0
                sumVoucherAmount = sumVoucherAmount + voucher.voucherAmount

                return {
                    ...voucher,
                    averageBasket: parseInt((voucher.orders.reduce((sum, item) => sum + parseInt(item.total), 0)) / voucher?.orders?.length),
                    averageItemCountInBasket: ((voucher.orders.reduce((sum, item) => sum + parseInt(item.line_items?.length), 0)) / voucher?.orders?.length).toFixed(1),
                    voucherAmount: parseInt((voucher.orders.reduce((sum, item) => sum + parseInt(item.voucherAmount), 0)) / voucher?.orders?.length),
                }
            })

            vouchers = vouchersApiData.map(voucherApiData => ({ ...voucherApiData, ...vouchers.find(vouchers => vouchers.voucherCode == voucherApiData.code) }))
            setVouchersData(vouchers)
        }
    }, [orders, vouchersApiData])

    const columns = [
        {
            id: "code",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "کد تخفیف",
        },
        {
            id: "discount_type",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "نوع کد تخفیف",
        },
        {
            id: "voucherAmount",
            cell: (info) => info.getValue() ? numberWithCommas(info.getValue()) + " تومان" : "---",
            header: "میانگین مبلغ کد تخفیف",
        },
        {
            id: "orders",
            cell: (info) => info.getValue() ? info.getValue().length : "0",
            header: "تعداد استفاده",
        },
        {
            id: "averageBasket",
            cell: (info) => info.getValue() ? numberWithCommas(info.getValue()) + " تومان" : "---",
            header: "میانگین سبد خرید",
        },
        {
            id: "averageItemCountInBasket",
            cell: (info) => info.getValue() ? info.getValue() + " قلم" : "---",
            header: "میانگین تعداد کالا در سبد خرید",
        },
        {
            id: "date_created",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue(), "en", "YYYY-MM-DD HH:mm:ss")
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            filterFn: (row, columnId, filterValue) => {
                // type can be "object" , "array" , "string" , "number"
                return FilterFn(row, columnId, filterValue, "date");
            },
            meta: {
                filterComponent: (setFilterValue, column, table, backendFilters, setBackendFilters) => {
                    return <FilterColumn setFilterValue={setFilterValue} column={column} table={table} backendFilters={backendFilters} setBackendFilters={setBackendFilters} type="date" />;
                },
            },
            header: "تاریخ ایجاد",
            inExport: false,
        },
        {
            id: "id",
            cell: (info) => (
                <div className="flex gap-2">
                    {
                        info.row.original.usage_count
                            ?
                            <div
                                className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 bg-gray-50 dark:bg-gray-900 dark:hover:bg-gray-700 text-gray-400 p-2 rounded-lg"
                                onClick={() => {
                                    setRowData(info.row.original)
                                    setIsModalOpen(true)
                                }}
                            >
                                <TbEyeSearch className="text-blue-500" />
                            </div>
                            :
                            null
                    }
                </div>
            ),
            header: "عملیات",
            footer: (info) => info.column.id,
            enableColumnFilter: false,
        }
    ];



    return (
        <>
            <PageHeader
                title="لیست کدهای تخفیف"
            />
            <Table data={vouchersData} columns={columns} CSVExportPermission="exportMarketingVouchers" tableName="vouchersStatistics" />
            <Modal isOpen={isModalOpen} toggle={setIsModalOpen}>
                <ModalHeader></ModalHeader>
                <ModalBody>
                    <div className="p-4 flex flex-col gap-3">
                        {
                            rowData && rowData?.orders?.map(order => {
                                return (
                                    <div className="p-2 flex flex-col lg:flex-row items-center justify-between gap-2 w-full border border-gray-200 rounded-xl">
                                        <div className="flex flex-col lg:flex-row gap-3 items-center">
                                            <div className="flex gap-2 items-center">
                                                <span className="text-xs">
                                                    ({order?.id})
                                                </span>
                                                <span className="text-sm">
                                                    {order?.fullName}
                                                </span>

                                            </div>
                                            <div className="flex gap-2 items-center">
                                                <div className="flex gap-1 items-center dark:bg-gray-700 bg-gray-100 px-2 py-1 rounded-lg text-xs">
                                                    <span>تعداد اقلام سفارش: </span>
                                                    <span>{order?.line_items?.length}</span>
                                                    <span>عدد</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-1 mx-2">
                                            <span className="text-sm">
                                                مجموع سبد خرید:
                                            </span>
                                            <span className="mx-1">
                                                {numberWithCommas(order.total)}
                                            </span>
                                            <span className="font-semibold">
                                                {/* {numberWithCommas(item.price * item.quantity)} */}
                                            </span>
                                            <span className="text-xs">تومان</span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        acceptTitle={false}
                        isCompact={true}
                        rejectTitle="بستن"
                        rejectHandle={() => { setIsModalOpen(false) }}
                    />
                </ModalFooter>
            </Modal>
        </>
    )
}
